import { PersonAddOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'
import { Bucket, BucketType } from '../../../../graphql/generated'
import { activeBucketIdVar, modalVar } from '../../../../providers/apollo/cache'
import useBucketUpdate from '../../hooks/useBucketUpdate'

interface Props {
  bucket: Bucket
}

export default function InviteButton({ bucket }: Props) {
  const { mutation: mutationBucketUpdate } = useBucketUpdate()
  const isGroupBucket = bucket?.bucketType === BucketType.Group
  const isDefaultTitle = bucket?.title?.toLowerCase() === 'my bucket' && bucket.bucketType === BucketType.Mybucket
  const isSharingPlan = bucket?.plan?.is_sharing_plan

  const handleClickInvite = () => {
    if (!isGroupBucket && isSharingPlan && !isDefaultTitle) {
      activeBucketIdVar(bucket?.id)
      mutationBucketUpdate({
        variables: {
          bucketId: bucket?.id,
          data: { bucketType: BucketType.Group }
        },
        onCompleted: () => {
          modalVar('bucketInvite')
        }
      })
    } else {
      activeBucketIdVar(bucket?.id)
      const modal = bucket?.bucketType === BucketType.Group ? 'bucketInvite' : 'bucketUpgrade'
      modalVar(modal)
    }
  }

  return (
    <Button
      data-test={`manage-bucket-${bucket.id}`}
      variant="contained"
      size="small"
      onClick={handleClickInvite}
      sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, gap: '8px', borderRadius: '40px', padding: '4px 16px', boxShadow: 'none' }}
    >
      <PersonAddOutlined sx={{ fontSize: '1.25rem' }} />
      Invite
    </Button>
  )
}
